var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.3143 25.3125L62.5018 29.6094L54.6893 37.0312V62.5H65.6268C68.2158 62.5 70.3143 60.4016 70.3143 57.8125V25.3125Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 25.3125L10.3344 27.9844L20.3125 37.0312V62.5H9.375C6.78594 62.5 4.6875 60.4016 4.6875 57.8125V25.3125Z",
    fill: "#1E88E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6875 17.4922L37.5 30.3828L20.3125 17.4922L18.75 26.5547L20.3125 37.0234L37.5 49.9141L54.6875 37.0234L56.25 26.5547L54.6875 17.4922Z",
    fill: "#E53935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 19.2234V25.3203L20.3125 37.0391V17.5078L15.4312 13.85C14.2688 12.9781 12.8562 12.5078 11.4031 12.5078C7.69375 12.5078 4.6875 15.5141 4.6875 19.2234Z",
    fill: "#C62828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3143 19.2234V25.3203L54.6893 37.0391V17.5078L59.5705 13.85C60.733 12.9781 62.1455 12.5078 63.5986 12.5078C67.308 12.5078 70.3143 15.5141 70.3143 19.2234Z",
    fill: "#FBC02D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.4f72fb1ae0f0d1ff75c965f2ba30b978.svg";
export { ForwardRef as ReactComponent };